// extracted by mini-css-extract-plugin
export default {"smsTemplate":"Client-smsTemplate-f38b"};